export default __webpack_public_path__ + "static/four-hair-cd67f40390950d00ec5b9cea8f2ccc8d.jpg";